<template>
    <a-modal title="修改条件属性"
             :width="780"
             :visible="visible"
             :maskClosable="false"
             class="wf-editor-modal"
             destroyOnClose
             @ok="onOk"
             @cancel="onCancel">
        <div :style="{ height: '400px' }" style="overflow-y:auto;overflow-x:hidden;">
        <a-form :form="form" class="form-input about">
            <a-row>
                <a-col :span="24">
                    <a-form-item label="条件名称" v-bind="formItemOneLayout">
                        <a-input v-decorator="['name',{initialValue:formData.name, rules: [{ required: true, message: '请输入条件名称'}]}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="顺序号" v-bind="formItemLayout">
                        <a-input-number v-decorator="['seqNo',{initialValue:formData.seqNo, rules: [{ type: 'number'}]}]" placeholder="顺序号" :min="1"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="时间限制" v-bind="formItemLayout">
                        <a-input v-decorator="['limit',{initialValue:formData.limit}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="路径类别" v-bind="formItemLayout">
                        <a-select v-decorator="['flowType',{initialValue:formData.flowType}]" @change="onChangeFlowType">
                            <a-select-option value="F">送件</a-select-option>
                            <a-select-option value="B">退件给送件人</a-select-option>
                            <a-select-option value="T">废弃</a-select-option>
                            <a-select-option value="C">办结</a-select-option>
                            <a-select-option value="D">归档</a-select-option>
                            <a-select-option value="X">反馈至路径[送件人]</a-select-option>
                            <a-select-option value="Y">反馈至路径[收件人]</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="步骤权限" v-bind="formItemLayout">
                        <a-select v-decorator="['perm',{initialValue:formData.perm}]">
                            <a-select-option value="R">只读</a-select-option>
                            <a-select-option value="W">可编辑</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="提示语句" v-bind="formItemOneLayout">
                        <a-input v-decorator="['tips',{initialValue:formData.tips}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="Ajax-action" v-bind="formItemOneLayout">
                        <a-input v-decorator="['ajax',{initialValue:formData.ajax}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="步骤事件" v-bind="formItemOneLayout">
                        <a-checkbox-group v-decorator="['events',{initialValue:formData.events}]">
                            <a-row>
                                <a-col :span="4"><a-checkbox value="C">可成文</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="P">可发布</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="D">可归档</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="L">可缮印</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="B">可办理</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="G">可取文号</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="E">可套红头</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="A">可调度</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="H">可封发</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="O">可校对</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="S">可签发</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="I">可督办</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="R">可回执</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="J">可远程发文</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="F">可公文交换</a-checkbox></a-col>
                                <a-col :span="4"><a-checkbox value="Z">可发市政府</a-checkbox></a-col>
                            </a-row>
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="执行服务" v-bind="formItemOneLayout">
                        <div class="frame">
                            <div class="frameTitle">
                                <span>当前已选择服务：</span>
                                <span class="services" v-for="(item, index) in serviceSelected" :key="index">
                                   {{item.name}}
                                   <svg class="fx-icon" style="cursor:pointer" aria-hidden="true" @click="onRemoveService(item.id)">
                                       <use xlink:href="#fx-delete"></use>
                                   </svg>
                               </span>
                            </div>
                            <div style="display:flex;">
                                <div class="frameLeft">
                                    <div class="leftTitle">
                                        <svg class="fx-icon" aria-hidden="true">
                                            <use xlink:href="#fx-setting"></use>
                                        </svg>
                                        分类目录
                                    </div>
                                    <div class="leftContent">
                                        <div v-for="(item, index) in osSummaryList" :key="index" @click="onShowServiceList(item)" class="os-item">
                                            <svg class="fx-icon" aria-hidden="true">
                                                <use xlink:href="#fx-folder"></use>
                                            </svg>
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="frameRight">
                                    <div class="rightTitle">服务</div>
                                    <a-checkbox-group :value="serviceSelectedIds">
                                        <a-row v-for="(item, index) in serviceList" :key="index">
                                            <a-col :offset="2" :span="24"><a-checkbox :value="item.id" @change="onChangeService">{{item.name}}</a-checkbox></a-col>
                                        </a-row>
                                    </a-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <a-form-item class="form-item-slim" label="服务脚本" v-bind="formItemOneLayout">
                        <a-textarea v-decorator="['script',{initialValue:formData.script}]" style="height:100px;">
                        </a-textarea>
                        <div style="line-height:normal">
                        当前支持函数为：<br>
                        #updateDBValue(表名,Id字段名,目标修改字段名,目标值)# <br>
                        例子：<br>
                        #updateDBValue(fx_user,id,state,A)#<br>
                        目标值可以为 @toUser 表示发向的目标人员（只能是单个）
                        </div>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24">
                    <div v-show="showRouteList">
                        请选择一个路径：
                        <br>
                        <a-radio-group v-model="formData.selectedRoute">
                            <a-row v-for="(item, index) in routeList" :key="index">
                                <a-col :offset="2" :span="24"><a-radio :value="item.id">{{item.name}}<span style="color:#aaa;margin-left:6px">{{item.desc}}</span></a-radio></a-col>
                            </a-row>
                        </a-radio-group>
                    </div>
                </a-col>
            </a-row>
        </a-form>
        </div>
    </a-modal>
</template>
<script>
export default {
  props: {},
  data () {
    return {
      formItemLayout: {
        labelCol: {
          md: { span: 6 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      formItemOneLayout: {
        labelCol: {
          md: { span: 3 }
        },
        wrapperCol: {
          md: { span: 20 }
        }
      },
      value: [],
      form: this.$form.createForm(this),
      formData: {
        name: '',
        seqNo: 10,
        limit: '',
        flowType: 'F',
        perm: 'R',
        tips: '',
        ajax: '',
        events: [],
        execClassIds: '',
        script: '',
        ruleScript: '',
        selectedRoute: null
      },
      wfNode: null,
      visible: false,
      osSummaryList: [],
      serviceList: [],
      serviceSelected: [],
      serviceSelectedIds: [],
      showRouteList: false,
      routeList: []
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.visible = true
      this.onRestForm()
      this.onInit()
    },
    onRestForm () {
      this.formData = {
        name: '',
        seqNo: 10,
        limit: '',
        flowType: 'F',
        perm: 'R',
        tips: '',
        ajax: '',
        events: [],
        execClassIds: '',
        script: '',
        ruleScript: '',
        selectedRoute: null
      }
      this.serviceSelected = []
      this.serviceSelectedIds = []
    },
    onInit () {
      this.onInitRoutes()

      this.$http.get('/api/1/workflow/cate/get_os_root_summary.json').then((resp) => {
        this.osSummaryList = resp.result
        this.formData.name = this.wfNode.getName()
        this.wfNode.pushWFAttributes(this.formData)
        this.onInitServices()
        this.onInitPage()
      })
    },
    onInitServices () {
      if (!this.formData.execClassIds) {
        return
      }
      this.$http.get('/api/1/workflow/design/check_service_state.json?ids=' + this.formData.execClassIds).then((resp) => {
        let result = []
        let resultIds = []
        for (let i = 0; i < resp.result.length; i++) {
          let item = resp.result[i]
          result.push({ id: item.id, name: item.name })
          resultIds.push(item.id)
        }
        this.serviceSelected = result
        this.serviceSelectedIds = resultIds
      })
    },
    onInitRoutes () {
      let wf = this.wfNode.workflow
      let roads = this.wfNode.workflow.getRoads()
      let result = []
      let routes = []
      let road = null
      for (let i in roads) {
        road = roads[i]
        if (road === null) {
          continue
        }
        for (let j = 0; j < road.length; j++) {
          let r = road[j]
          if (r != null) {
            if (routes[r.uuid()] == null) {
              routes[r.uuid()] = r
            }
          }
        }
      }

      for (let i in routes) {
        let r = routes[i]
        let id = r.uuid()
        let name = r.getName()
        let desc = '[' + wf.getElement(r.getStart()).getName() + '->' + wf.getElement(r.getEnd()).getName() + ']'

        result.push({ id: id, name: name, desc: desc })
      }

      this.routeList = result
    },
    onInitPage () {
      this.onChangeFlowType(this.formData.flowType)
    },
    onShowServiceList (osSummary) {
      this.serviceList = osSummary.extras.serviceList
    },
    onChangeService (e) {
      const value = e.target.value
      if (e.target.checked) {
        // 选中
        this.serviceSelected = [...this.serviceSelected, ...this.serviceList.filter(item => item.id === value)]
        this.serviceSelectedIds = [...this.serviceSelectedIds, ...[value]]
      } else {
        // 删除
        this.serviceSelected = this.serviceSelected.filter(item => item.id !== value)
        this.serviceSelectedIds = this.serviceSelectedIds.filter(id => id !== value)
      }
    },
    onRemoveService (sId) {
      this.serviceSelected = this.serviceSelected.filter(item => item.id !== sId)
      this.serviceSelectedIds = this.serviceSelectedIds.filter(id => id !== sId)
    },
    onChangeFlowType (value) {
      if (value === 'X' || value === 'Y') {
        // 路径反馈时列出路径
        this.showRouteList = true
      } else {
        this.showRouteList = false
      }
    },
    onOk () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let data = this.form.getFieldsValue()
        this.formData = Object.assign(this.formData, data)
        this.formData.execClassIds = this.serviceSelectedIds.join(',')

        if (this.formData.flowType === 'X' || this.formData.flowType === 'Y') {
          if (!this.formData.selectedRoute) {
            alert('你选择了反馈至路径，但还没有选择任何路径')
            return
          }
          this.formData.ruleScript = this.formData.selectedRoute
        }

        this.wfNode.setName(this.formData.name)
        this.wfNode.setOrder(this.formData.seqNo)
        this.wfNode.setWFAttributes('FORM', this.formData)
        this.wfNode.setWFAttributes('ROUTE_TYPE', this.formData.flowType)
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.visible = false
    },
    onChange (checkedValues) {
      console.log('checked = ', checkedValues)
    }
  }
}
</script>
<style scoped lang="less">
    .frame {
        border: 1px solid #cdcdcd;

        .frameTitle {
            padding-left: 10px;
            border-bottom: 1px solid #cdcdcd;
            line-height: 28px;

            .services {
                color: #0050b3;
                margin-right: 10px;
            }
        }

        .frameLeft {
            width: 50%;
            border-right: 1px solid #cdcdcd;

            .leftTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }

            .leftContent {
                padding-left: 10px;
            }
        }

        .frameRight {
            width: 50%;

            .rightTitle {
                border-bottom: 1px solid #cdcdcd;
                padding-left: 10px;
                line-height: 28px;
                background-color: #E4E8F8;
            }
        }
    }

    .form-item-slim {
        margin-bottom: 8px
    }

    .os-item {
        line-height: 24px;
        cursor: pointer;
    }
</style>
<style lang="less">
    .wf-editor-modal .ant-modal-body {
        padding: 8px 0 8px 14px !important;
    }

    .wf-editor-modal .ant-form-item-label {
        line-height: 28px;
    }
</style>
